export const CAR_HIRE_EXCESS_UK = 'CarHireExcessUk';
export const CAR_HIRE_EXCESS_IE = 'CarHireExcessIe';
export const CAR_HIRE_EXCESS_BLUE_IE = 'CarHireBlueIe';
